<template>
  <page-outline :title="store === '0' ?$t('common.security.add_pem', {itemLabel: 'truststore'}):$t('common.security.add_pem', {itemLabel: 'keystore'})">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button></back-button>
          </b-col>
        </b-row>
        <div v-if="store === '0'">
          <!--form-accordion v-if="isRightPod" :title="$t('common.security.pem')" :isTitleUpperCase="false" >
            <b-row class="d-flex justify-content-center align-items-center">
              <b-col sm="4" class="form-group">
                <div>
                  <span class="filter-item-title">{{ $t('common.security.pod_select') }}</span>
                  <span class="color-red">* </span>
                  <b-form-select v-model="form.pod" :options="podList" style="font-size:small;"></b-form-select>
                </div>
              </b-col>
              <b-col sm="4" class="form-group"></b-col>
              <b-col sm="4" class="form-group"></b-col>
            </b-row>
          </form-accordion-->
          <form-accordion :title="$t('common.security.certificat')" :isTitleUpperCase="false">
            <button class="btn w-auto px-4 btn-tertiary mb-3" @click="addCertificat">{{ $t('common.security.add_certificat') }}</button>
            <div class="rounded p-4 trackingAccordion mb-5" v-for="(certificat, index) in certificatList" :key="index">
              <b-row class="d-flex justify-content-center align-items-center">
                <b-col v-if="certificat.text == ''"  sm="4" class="form-group mb-5">
                  <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
                  <span class="color-red">* </span>
                  <b-form-textarea
                    style="max-height: none;"
                    id="textarea"
                    v-model="certificat.text"
                    @input="processCertificat"
                    :placeholder="$t('common.enter_something')"
                    rows="6">
                  </b-form-textarea>
                </b-col>
                <b-col v-if="certificat.text !== ''"  sm="12" class="form-group mb-5">
                  <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
                  <span class="color-red">* </span>
                  <b-form-textarea
                    style="max-height: none;"
                    id="textarea"
                    v-model="certificat.text"
                    @input="processCertificat"
                    :placeholder="$t('common.enter_something')"
                    rows="6">
                  </b-form-textarea>
                </b-col>
                <b-col sm="4" class="form-group d-flex flex-column mb-5" v-if="certificat.text === ''" >
                  <span>
                    <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
                    <span class="color-red">* </span>
                  </span>
                  <input type="file" @change="handleFileUploadCertificat($event, index)" accept=".pem" />
                </b-col>
                <b-col  v-if="certificat.text === ''" sm="4" class="form-group"></b-col>
              </b-row>
              <b-row class="d-flex align-items-center">
                <b-col sm="4" class="form-group mb-5">
                  <form-write-group-label-input v-model="certificat.name" isMandatory
                    :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
                  </form-write-group-label-input>
                </b-col>
                <b-col sm="4" class="form-group mb-5">
                  <form-read-group-label-input :inputValue="certificat.startDate"
                    :inputLabel="$t('common.security.startDate')" :placeholderValue="$t('common.security.startDate')">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="form-group mb-5">
                  <form-read-group-label-input :inputValue="certificat.endDate"
                    :inputLabel="$t('common.security.endDate')" :placeholderValue="$t('common.security.endDate')">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="2" class="form-group">
                </b-col>
              </b-row>
              <b-row class="d-flex align-items-center form-group">
                <b-col sm="4" class="form-group">
                  <form-read-group-label-input :inputValue="certificat.deliveredBy"
                    :inputLabel="$t('common.security.deliveredBy')" :placeholderValue="$t('common.security.deliveredBy')">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="form-group">
                  <form-read-group-label-input :inputValue="certificat.deliveredTo"
                    :inputLabel="$t('common.security.deliveredTo')" :placeholderValue="$t('common.security.deliveredTo')">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="form-group">
                </b-col>
              </b-row>
              <button class="btn w-auto px-4 btn-tertiary" @click="removeCertificat(index)">{{ $t('common.security.remove_certificat') }}</button>
            </div>
          </form-accordion>
        </div>
        <div v-else-if="store === '1'">
          <form-accordion :title="$t('common.security.pem')" :isTitleUpperCase="false" >
            <b-row class="d-flex form-group">
              <!--b-col sm="6" class="form-group">
                <div>
                  <span class="filter-item-title">{{ $t('common.security.pod_select') }}</span>
                  <span class="color-red">* </span>
                  <b-form-select v-model="form.pod" :options="podList" style="font-size:small;"></b-form-select>
                </div>
              </b-col-->
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="form.name" isMandatory
                  :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
                </form-write-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>
          <hr  class="mx-auto mb-4" />
          <form-accordion :title="$t('common.security.certificat')" :isTitleUpperCase="false">
            <b-row v-if="certificateText === ''" class="d-flex justify-content-center align-items-center form-group">
              <b-col sm="6" class="form-group mb-5">
                <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
                <span class="color-red">* </span>
                <b-form-textarea
                  style="max-height: none;"
                  id="textarea"
                  v-model="certificateText"
                  @input="processCertificat"
                  :placeholder="$t('common.enter_something')"
                  rows="6">
                </b-form-textarea>
              </b-col>
              <b-col sm="6" class="form-group mb-5 d-flex flex-column form-group" v-if="certificateText === ''" >
              <span>
                <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
                <span class="color-red">* </span>
              </span>
                <input type="file" @change="handleFileUploadCertificat" accept=".pem" />
              </b-col>
            </b-row>
            <b-row v-if="certificateText !== ''" class="d-flex justify-content-center align-items-center form-group">
              <b-col sm="12" class="form-group mb-5">
                <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
                <span class="color-red">* </span>
                <b-form-textarea
                  style="max-height: none;"
                  id="textarea"
                  v-model="certificateText"
                  @input="processCertificat"
                  :placeholder="$t('common.enter_something')"
                  rows="6">
                </b-form-textarea>
              </b-col>
              <b-col sm="6" class="form-group mb-5 d-flex flex-column" v-if="certificateText === ''" >
              <span>
                <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
                <span class="color-red">* </span>
              </span>
                <input type="file" @change="handleFileUploadCertificat" accept=".pem" />
              </b-col>
            </b-row>
            <b-row class="d-flex align-items-center form-group">
              <b-col sm="6" class="form-group mb-5">
                <form-read-group-label-input :inputValue="form.startDate"
                  :inputLabel="$t('common.security.startDate')" :placeholderValue="$t('common.security.startDate')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputValue="form.endDate"
                  :inputLabel="$t('common.security.endDate')" :placeholderValue="$t('common.security.endDate')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="2" class="form-group">
              </b-col>
            </b-row>
            <b-row class="d-flex align-items-center">
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputValue="form.deliveredBy"
                  :inputLabel="$t('common.security.deliveredBy')" :placeholderValue="$t('common.security.deliveredBy')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :inputValue="form.deliveredTo"
                  :inputLabel="$t('common.security.deliveredTo')" :placeholderValue="$t('common.security.deliveredTo')">
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>
          <hr  class="mx-auto mb-4" />
          <form-accordion :title="$t('common.security.private_key')" :isTitleUpperCase="false">
            <b-row class="d-flex justify-content-center align-items-center form-group">
              <b-col v-if="privateKeyText === ''" sm="6" class="form-group">
                <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
                <span class="color-red">* </span>
                <b-form-textarea
                  style="max-height: none;"
                  id="textarea"
                  v-model="privateKeyText"
                  @input="processPrivateKey"
                  :placeholder="$t('common.enter_something')"
                  rows="6">
                </b-form-textarea>
              </b-col>
              <b-col v-if="privateKeyText !== ''" sm="12" class="form-group">
                <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
                <span class="color-red">* </span>
                <b-form-textarea
                  style="max-height: none;"
                  id="textarea"
                  v-model="privateKeyText"
                  @input="processPrivateKey"
                  :placeholder="$t('common.enter_something')"
                  rows="6">
                </b-form-textarea>
              </b-col>
              <b-col sm="6" class="form-group d-flex flex-column" v-if="privateKeyText === ''" >
                <span>
                  <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
                  <span class="color-red">* </span>
                </span>
                <input type="file" @change="handleFileUploadPrivateKey" accept=".key" />
              </b-col>
            </b-row>
            <b-row class="d-flex justify-content-center align-items-center form-group">
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="form.password"
                  :inputLabel="$t('common.security.password')" :placeholderValue="$t('common.security.password')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group"></b-col>
            </b-row>
          </form-accordion>
        </div>
        <b-row v-if="store === '0'" class="mt-3 justify-content-end">
          <b-col cols="6" lg="3" xl="2" v-if="canSaveTrustStore">
            <b-button variant="primary"
              @click="showModal('create')">
              <i class="fa-light fa-save"></i>
              <span>{{ $t('common.security.link_truststore') }}</span>
            </b-button>
          </b-col>
          <b-col cols="6" lg="3" xl="2" v-else>
            <b-button variant="primary" disabled>
              <i class="fa-light fa-save"></i>
              <span>{{ $t('common.security.link_truststore') }}</span>
            </b-button>
          </b-col>
          <b-col cols="6" lg="3" xl="2" v-if="canSaveTrustStore">
            <b-button variant="primary"
              @click="showModal('link')">
              <i class="fa-light fa-save"></i>
              <span>{{ $t('common.security.create_truststore') }}</span>
            </b-button>
          </b-col>
          <b-col cols="6" lg="3" xl="2" v-else>
            <b-button variant="primary" disabled>
              <i class="fa-light fa-save"></i>
              <span>{{ $t('common.security.create_truststore') }}</span>
            </b-button>
          </b-col>

        </b-row>
        <b-row v-else-if="store === '1'" class="mt-3 justify-content-end">
          <b-col cols="6" lg="3" xl="2" v-if="form.name !== '' && form.certificate !== '' && form.privateKey !== '' && form.startDate !== '' && form.endDate !== ''">
            <b-button variant="primary"
              @click="createKeystore()">
              <i class="fa-light fa-save"></i>
              <span>{{ $t('common.security.add_keystore') }}</span>
            </b-button>
          </b-col>
          <b-col cols="6" lg="3" xl="2" v-else>
            <b-button variant="primary" disabled>
              <i class="fa-light fa-save"></i>
              <span>{{ $t('common.security.add_keystore') }}</span>
            </b-button>
          </b-col>
        </b-row>
        <security-pop-up v-if="showModalElement" @close="close" @savepopup="createTruststore" :caList="caListPopUp" ></security-pop-up>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import forge from 'node-forge';
import CertificatesList from "@/pages/security/CertificatesList.vue";
import {ind} from "@/static/ocr/worker";
import _ from "lodash";
import SecurityPopUp from "@/popups/security/SecurityPopUp.vue";
import {loadPage} from "@/helpers/routing";

export default {
  name: 'SecurityFormPEM',
  computed: {
    CertificatesList() {
      return CertificatesList
    }
  },
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'security-pop-up': SecurityPopUp
  },
  props: ['store'],
  data () {
    return {
      form: {
        state: 0,
        privateKey: '',
        certificate: '',
        startDate: '',
        endDate: '',
        deliveredBy: '',
        deliveredTo: '',
        name: '',
        nameDisplay: '',
        pod: '',
        password:'',
        id: '',
      },
      text: '',
      certificateText: '',
      privateKeyText: '',
      active: '0',
      filteredNorms: [],
      hrtpNorm: false,
      login: '',
      name: '',
      password: '',
      passwordType: 'password',
      profiles: [],
      srtpNorm: false,
      showModalElement: false,
      id_rights_profile: '',
      caList: [],
      caListPopUp: [],
      podList: [],
      canSaveTrustStore: false,
      certificatList: []
    }
  },
  watch: {
    certificatList: {
      handler() {
        this.checkFormTrustStore()
      },
      deep: true,
    },
    form: {
      handler() {
        this.checkFormTrustStore()
      },
      deep: true,
    },
  },
  created () {
    this.profiles = this.$engine.company.profiles.sort((a, b) => {
      return a.libelle.toUpperCase() > b.libelle.toUpperCase() ? 1 : -1
    })
    this.$engine.security.ca.fetch().then(resp => {
      if (resp.data.ca.length > 0){
        this.caList.push({text: this.$i18n.t('common.security.select_an_option'), value: ''})
        resp.data.ca.forEach(element => {
          this.caList.push({text: element.name, value: element.id})
        })
      }

    })
    .catch(error => {
      errorMessageAlert(error, that)
    })
    /*this.$engine.routing.pod.fetch()
        .then(resp => {
          if (resp.data.Pods.length != 0){
            this.podList.push({text: this.$i18n.t('common.security.select_an_option'), value: ""})
            resp.data.Pods.forEach(element => {
              this.podList.push({text: element.name, value: element.name})
            })
          }

        })*/
    this.filteredNorms = _.cloneDeep(this.profiles.filter(profile => {
      return profile.libelle.includes('Norm_')
    }))
    let that = this
    this.filteredNorms.forEach(profile => {
      profile.active = 0
      profile.libelle = that.$i18n.t('requestToPay.norms.' + profile.libelle.split('_')[1])
    })
    this.filteredNorms.sort(function (a, b) {
      return a.libelle < b.libelle ? -1 : 1
    })
  },
  methods: {
    /*isRightPod(){
      return this.$engine.rights.rightIs('pod_consult', true)
    },*/
    addCertificat () {
      this.certificatList.push({startDate: '', endDate: '', name: '',text: '', certificat: '', nameDisplay: ''})
      this.checkFormTrustStore()
    },
    removeCertificat (index) {
      this.certificatList.splice(index , 1)
    },
    checkFormTrustStore () {
      let flag = true
      this.certificatList.forEach(element =>{
        if (element.startDate != '' && element.endDate != '' && element.certificate != '' && element.nameDisplay != '' && element.name != ''){

        }else{
          flag = false
        }
      })
      if (flag){
        this.canSaveTrustStore = true
      }
      else{
        this.canSaveTrustStore = false
      }
    },
    showModal (method) {
      if (method === 'create'){
        this.caListPopUp = this.caList
      } else if (method === 'link'){
        this.caListPopUp = null
      }
      this.checkFormTrustStore()
      if (this.canSaveTrustStore){
        this.showModalElement = true
      } else{
        this.showModalElement = false
      }
    },
    close () {
      this.showModalElement = false
    },
    processPrivateKey () {
      try {
        // Traiter le certificat PEM collé dans le textarea
        let privateKey = forge.pki.privateKeyFromPem(this.privateKeyText);

        // Convertir l'objet clé privée en format PEM pour l'afficher
        this.form.privateKey = forge.pki.privateKeyToPem(privateKey);

        // Réinitialiser le message d'erreur s'il y en avait
        this.errorMessage = ''
      } catch (err) {
        // En cas d'erreur, afficher un message
        this.errorMessage = this.$i18n.t('common.security.pem_certificate_parsing_error')
        this.form.certificate = ''
        this.form.privateKeyText = ''
        this.form.startDate = ''
        this.form.endDate = ''
      }
    },
    processCertificat() {
      try {
        // Traiter le certificat PEM collé dans le textarea
         const certificate = forge.pki.certificateFromPem(this.certificateText);

        // Extraire les informations du certificat
        const subjectAttributes = certificate.subject.attributes;
        const commonNameAttribute = subjectAttributes.find(attr => attr.name === 'commonName');
        this.form.name = commonNameAttribute ? commonNameAttribute.value : 'Nom non trouvé';

        this.form.startDate = certificate.validity.notBefore.toLocaleString().toString();
        this.form.endDate = certificate.validity.notAfter.toLocaleString().toString();

        // Reconversion du certificat en format PEM (pour l'affichage)
        this.form.certificate = forge.pki.certificateToPem(certificate);

        certificate.issuer.attributes.forEach(element => {
          if (element.name == 'commonName'){
            this.form.deliveredBy = element.value
          }
        })
        certificate.subject.attributes.forEach(element => {
          if (element.name == 'commonName'){
            this.form.deliveredTo = element.value
          }
        })

        // Réinitialiser le message d'erreur s'il y en avait
        this.errorMessage = '';

      } catch (err) {
        // En cas d'erreur, afficher un message
        this.errorMessage = this.$i18n.t('common.security.pem_certificate_parsing_error');
        this.form.certificate = '';
        this.form.startDate = '';
        this.form.endDate = '';
      }
    },
    handleFileUploadPrivateKey(event) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const keyContent = e.target.result

        try {
          const privateKey = forge.pki.privateKeyFromPem(keyContent)
          this.form.privateKey = forge.pki.privateKeyToPem(privateKey)
          this.privateKeyText = forge.pki.privateKeyToPem(privateKey)

        } catch (err) {
        }
      };

      reader.readAsText(file)
    },
    handleFileUploadCertificat(event, index = null) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const pemContent = e.target.result;

        try {
          const certificate = forge.pki.certificateFromPem(pemContent);
          const pemFormattedCert = forge.pki.certificateToPem(certificate)

          this.certificateText = forge.pki.certificateToPem(certificate)


          const startDate = certificate.validity.notBefore.toLocaleString().toString();
          const endDate = certificate.validity.notAfter.toLocaleString().toString();

          const subjectAttributes = certificate.subject.attributes;
          const commonNameAttribute = subjectAttributes.find(attr => attr.name === 'commonName');
          const name = commonNameAttribute ? commonNameAttribute.value : 'Nom non trouvé';

          if (index == null){
            this.form.certificate = pemFormattedCert
            this.form.startDate = startDate
            this.form.endDate = endDate
            this.form.nameDisplay = name

            certificate.issuer.attributes.forEach(element => {
              if (element.name == 'commonName'){
                this.form.deliveredBy = element.value
              }
            })
            certificate.subject.attributes.forEach(element => {
              if (element.name == 'commonName'){
                this.form.deliveredTo = element.value
              }
            })
          }else{
            this.certificatList[index].certificate = pemFormattedCert
            this.certificatList[index].startDate = startDate
            this.certificatList[index].endDate = endDate
            this.certificatList[index].nameDisplay = name

            certificate.issuer.attributes.forEach(element => {
              if (element.name == 'commonName'){
                this.certificatList[index].deliveredBy = element.value
              }
            })
            certificate.subject.attributes.forEach(element => {
              if (element.name == 'commonName'){
                this.certificatList[index].deliveredTo = element.value
              }
            })
          }

        } catch (err) {
          console.error(this.$i18n.t('common.security.pem_certificate_parsing_error'), err);
        }
      };

      reader.readAsText(file);
    },
    isCertificateAuthority(cert) {
      const basicConstraints = cert.getExtension('basicConstraints');
      return basicConstraints && basicConstraints.cA;
    },
    createTruststore(dataNameId){
      let that = this
      that.form.id = dataNameId.id
      that.form.name = dataNameId.name
      if (that.form.name != '' || that.form.id != ''){
        let certificates = []
        let flag
        flag = false
        let count = 0
        that.certificatList.forEach(element => {
          /*if (that.form.pod == '') {
            that.$f7.alert(that.$i18n.t('common.security.missing_truststore_pod'), 'Error')
          }*/
          if (element.name == '') {
            that.$f7.alert(that.$i18n.t('common.security.missing_truststore_name'), 'Error')
          }
          if(/*element.pod != '' ||*/ element.name){
            let form = {
              idPod: this.form.pod,
              name: element.name,
              certificate: element.certificate,
              startDate: element.startDate,
              endDate: element.endDate,
              deliveredBy: element.deliveredBy,
              deliveredTo: element.deliveredTo,
              commonName: element.nameDisplay,
              type: 'SSL'
            }

            if (that.formHasError()) {
              return
            }

            that.$engine.security.certificates.create(form)
            .then(resp => {

              count++
              certificates.push(resp.data.idCertificat)

              let form = {
                certificates: certificates,
                type: 'SSL',
                idPod: this.form.pod
              }
              if (that.form.name != ''){
                form.name = that.form.name
              } else{
                form.idCA = that.form.id
              }

              if (that.formHasError()) {
                return
              }

              if (count === that.certificatList.length) {
                flag = true
              }
              if (flag) {
                that.$engine.security.ca.create(form)
                .then(resp => {
                  that.$f7.alert(that.$i18n.t('common.security.added_certificate_truststore'), that.$i18n.t('common.security.adding_certificate_truststore'))
                  loadPage(that, {url: '/security/'+ this.store})
                })
                .catch(e => {
                  errorMessageAlert(e, that)
                  that.okMessageBox(that.$t('common.security.add_certificate_truststore_error'))
                })
              }
            })
            .catch(e => {
              errorMessageAlert(e, that)
              that.okMessageBox(that.$t('common.security.cert_addition_error'))
            })
          }
        })
      }
    },
    createKeystore () {
      let that = this
        /*if (this.form.password === '') {
          this.$f7.alert(that.$i18n.t('common.security.missing_keystore_password'), 'Error')
        }*/
        /*else if (this.form.pod === '') {
          this.$f7.alert(that.$i18n.t('common.security.missing_keystore_pod'), 'Error')
        }*/
        if (this.form.name === '') {
          this.$f7.alert(that.$i18n.t('common.security.missing_keystore_name'), 'Error')
        }
        else if (this.form.privateKey === '') {
          this.$f7.alert(that.$i18n.t('common.security.missing_keystore_private_key'), 'Error')
        }
        else if (this.form.certificate === '') {
          this.$f7.alert(that.$i18n.t('common.security.missing_keystore_certificate'), 'Error')
        }
        else if (this.form.startDate === '') {
          this.$f7.alert(that.$i18n.t('common.security.missing_keystore_start_date'), 'Error')
        }
        else if (this.form.endDate === '') {
          this.$f7.alert(that.$i18n.t('common.security.missing_keystore_end_date'), 'Error')
        }
        if(this.form.password !== '' /*|| this.form.pod !== ''*/ || this.form.name !== ''){
          let form = {
            name: this.form.name,
            privateKey: this.form.privateKey,
            password: this.form.password,
            passwordVerif: this.form.password,
            idPod: this.form.pod,
            type: 'SSL'
          }
          let privateKeyId = ''
          let CertificateId = ''

          let that = this

          if (this.formHasError()) {
            return
          }

          this.$engine.security.private_keys.create(form)
          .then(resp => {
            privateKeyId = resp.data.idPrivateKey


            form = {
              idPod: this.form.pod,
              name: this.form.name,
              certificate: this.form.certificate,
              startDate: this.form.startDate,
              endDate: this.form.endDate,
              deliveredBy: this.form.deliveredBy,
              deliveredTo: this.form.deliveredTo,
              commonName: this.form.nameDisplay,
              type: 'SSL'
            }

            let that = this

            if (this.formHasError()) {
              return
            }

            this.$engine.security.certificates.create(form)
            .then(resp => {
              CertificateId = resp.data.idCertificat

              form = {
                privateKeyId,CertificateId,name: this.form.name
              }
              this.$engine.security.keystore.create(form)
              .then(resp => {
                that.$f7.alert(that.$i18n.t('common.security.created_keystore'), that.$i18n.t('common.security.creation_keystore'))
                loadPage(that, {url: '/security/'+ this.store})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            })
            .catch(e => {
              errorMessageAlert(e, that)
              that.okMessageBox(that.$t('common.security.cert_addition_error'))
            })

          })
          .catch(e => {
            errorMessageAlert(e, that)
            that.okMessageBox(this.$t('common.security.priv_key_addition_error'))
          })
        }

    },
    formHasError () {
      // let that = this
      // let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      // if (this.login === undefined || this.login === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_login'))
      //   return true
      // }
      // if (this.name === undefined || this.name === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_name'))
      //   return true
      // }
      // if (this.password === undefined || this.password === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_password'))
      //   return true
      // }
      // if (this.password && !regexPassword.test(this.password)) {
      //   this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
      //   return true
      // }
      // if (!this.realProfileList.filter(status => status.state === 1
      //     && ((that.hrtpNorm && status.label.includes('_HRTP'))
      //         || (that.srtpNorm && status.label.includes('_SRTP'))
      //         || (!status.label.includes('_HRTP') && !status.label.includes('_SRTP')))).length) {
      //   this.okMessageBox(this.$t('usercompany.missing_profile'))
      //   return true
      // }
      // return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
